export default __webpack_public_path__ + "static/bgImage-623530f49f60d35c5c539b7540b6286c.png";